import { ITooltipProps, Text } from '@fluentui/react';
import * as React from 'react';
import * as Styled from '../Styles/labels.styled';

export const ingestionTypeTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>Mode of data ingestion into HR Data Platform:</Text>
        <Text>1. Standard: Data ingestion through Service Bus</Text>
        <Text>2. Bulk: Data ingestion through file from Storage</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionMethodTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>How bulk data enters the HR Data Platform:</Text>
        <Text>1. Pull: HRDP pulls the data from your storage based on the ingestion frequency.</Text>
        <Text>2. Push: You are granted access to write the data directly to the HRDP lakehouse.</Text>
        <Text>3. Shortcut: HRDP creates a shortcut from your data store to the HRDP bronze lakehouse.</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionStorageAccNameTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>Data is bulk ingested from specified Storage Account into the HR Data Platform.</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionClientIdTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>
          The specified Client ID Guid is used for authentication of the HRDP to access the specified Storage Account.
        </Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionClientSecretNameTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>
          The Client Secret value will be retrived from the specified 'Client Secret Name' field in the App
          Configuration and is used for authentication of the HRDP to access the specified Storage Account.
        </Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionStorageBasePathTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>
          This specifies the base path from which data is bulk ingested from specified Storage Account into the HR Data
          Platform.
        </Text>
        <Text>Format: abfss://&lt;containername&gt;publish@&lt;accountName&gt;.dfs.core.windows.net</Text>
        <Text>Example: abfss://publish@hcmlakeuat.dfs.core.windows.net</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionFileTypeTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>
          The specified type of file used for bulk ingestion of data from specified Storage Account into the HR Data
          Platform.
        </Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionFileNameTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>
          The specified name of the file used for bulk ingestion of data from specified Storage Account into the HR Data
          Platform. <br /> If '*' is specified, all the files in the folder path will be considered.
        </Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionFolderPathTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>
          This specifies the folder path of the file used for bulk ingested of data from specified Storage Account into
          the HR Data Platform.
        </Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionIdPropertyTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>This specifies the ID field that unique identifies data rows in bulk ingestion of data.</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionHandshakeTypeTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>Choose the appropriate Handshake type among the given Handshake Types for ingestion of data.</Text>
        <Text>1. None: No Handshake type required.</Text>
        <Text>2. Default: Default Handshake type implemented by HR Data Platform.</Text>
        <Text>
          3. Custom: Please give detailed explanation in the description property, so that HRDP team can implement the
          custom handshake type.
        </Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingestionHandshakeFilePathTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>
          This specifies the path of Handshake File used for bulk ingestion from specified Storage Account into the HR
          Data Platform.
        </Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const ingressFrequencyTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>The bulk ingestion job runs regularly at the selected frequency.</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};

export const eo14117ProtectedTooltipProps: ITooltipProps = {
  onRenderContent: () => {
    return (
      <Styled.CustomTooltipContainer>
        <Text>Select if this entity type contains EO14117-sensitive data.</Text>
      </Styled.CustomTooltipContainer>
    );
  },
};
